import { render, staticRenderFns } from "./expertIndex.vue?vue&type=template&id=52e8446f&scoped=true&"
import script from "./expertIndex.vue?vue&type=script&lang=js&"
export * from "./expertIndex.vue?vue&type=script&lang=js&"
import style0 from "./expertIndex.vue?vue&type=style&index=0&id=52e8446f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e8446f",
  null
  
)

export default component.exports